import React from 'react';
import {corneliusesLinks} from '../../utilities/urls';
import "./LinkFooter.css";

const LinkFooter = () => <div className='footer-container'>
    {corneliusesLinks.map(link => <a className='footer-link' href={link.url}>{link.title}</a>)}
</div>;

export default LinkFooter;